import { css as g, LitElement as h, nothing as m, html as d } from "lit";
import { property as t, customElement as c } from "lit/decorators.js";
import { classMap as u } from "lit/directives/class-map.js";
import { styleMap as v } from "lit/directives/style-map.js";
import { b } from "./styles-scZ6dVz-.js";
var f = Object.defineProperty, y = Object.getOwnPropertyDescriptor, e = (s, i, o, n) => {
  for (var a = n > 1 ? void 0 : n ? y(i, o) : i, p = s.length - 1, l; p >= 0; p--)
    (l = s[p]) && (a = (n ? l(i, o, a) : l(a)) || a);
  return n && a && f(i, o, a), a;
};
let r = class extends h {
  constructor() {
    super(...arguments), this.value = 0, this.max = 100, this.variant = "default", this.size = "md", this.indeterminate = !1, this.showValue = !1, this.striped = !1, this.animated = !1;
  }
  get percentage() {
    const s = Math.max(0, Math.min(this.value, this.max));
    return Math.round(s / this.max * 100);
  }
  render() {
    const s = {
      "progress-track": !0,
      [this.variant]: !0,
      [this.size]: !0,
      indeterminate: this.indeterminate,
      striped: this.striped && !this.indeterminate,
      animated: this.animated && this.striped && !this.indeterminate
    }, i = this.indeterminate ? {} : { width: `${this.percentage}%` }, o = this.label || this.showValue;
    return d`
      <div
        class="progress-container"
        role="progressbar"
        aria-valuenow=${this.indeterminate ? m : this.value}
        aria-valuemin="0"
        aria-valuemax=${this.max}
        aria-label=${this.label || "Progress"}
      >
        ${o ? d`
              <div class="progress-header">
                <span part="label" class="progress-label">
                  <slot>${this.label}</slot>
                </span>
                ${this.showValue && !this.indeterminate ? d`<span class="progress-value">${this.percentage}%</span>` : m}
              </div>
            ` : m}
        <div part="track" class=${u(s)}>
          <div part="bar" class="progress-bar" style=${v(i)}></div>
        </div>
      </div>
    `;
  }
};
r.styles = [
  b,
  g`
      :host {
        display: block;
        width: 100%;
      }

      .progress-container {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-1);
      }

      .progress-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: var(--r5-text-sm);
        color: var(--r5-text);
      }

      .progress-label {
        font-weight: var(--r5-font-medium);
      }

      .progress-value {
        color: var(--r5-text-muted);
        font-variant-numeric: tabular-nums;
      }

      .progress-track {
        position: relative;
        width: 100%;
        height: var(--r5-progress-height, 0.5rem);
        background-color: var(--r5-progress-track-color, var(--r5-bg-muted));
        border-radius: var(--r5-progress-radius, var(--r5-radius-full));
        overflow: hidden;
      }

      .progress-bar {
        height: 100%;
        border-radius: inherit;
        transition: width var(--r5-duration-normal) var(--r5-ease-out);
        background-color: var(--r5-progress-bar-color, var(--r5-color-primary-600));
      }

      /* Indeterminate animation */
      .indeterminate .progress-bar {
        width: 30% !important;
        animation: ark-progress-indeterminate 1.5s ease-in-out infinite;
      }

      @keyframes ark-progress-indeterminate {
        0% {
          transform: translateX(-100%);
        }
        50% {
          transform: translateX(200%);
        }
        100% {
          transform: translateX(-100%);
        }
      }

      /* Size variants */
      .sm {
        --r5-progress-height: 0.25rem;
      }

      .md {
        --r5-progress-height: 0.5rem;
      }

      .lg {
        --r5-progress-height: 0.75rem;
      }

      /* Color variants */
      .default .progress-bar {
        --r5-progress-bar-color: var(--r5-color-primary-600);
      }

      .success .progress-bar {
        --r5-progress-bar-color: var(--r5-color-success-600);
      }

      .warning .progress-bar {
        --r5-progress-bar-color: var(--r5-color-warning-600);
      }

      .danger .progress-bar {
        --r5-progress-bar-color: var(--r5-color-danger-600);
      }

      /* Striped pattern */
      .striped .progress-bar {
        background-image: linear-gradient(
          45deg,
          rgba(255, 255, 255, 0.15) 25%,
          transparent 25%,
          transparent 50%,
          rgba(255, 255, 255, 0.15) 50%,
          rgba(255, 255, 255, 0.15) 75%,
          transparent 75%,
          transparent
        );
        background-size: 1rem 1rem;
      }

      .striped.animated .progress-bar {
        animation: ark-progress-stripes 1s linear infinite;
      }

      @keyframes ark-progress-stripes {
        from {
          background-position: 1rem 0;
        }
        to {
          background-position: 0 0;
        }
      }
    `
];
e([
  t({ type: Number })
], r.prototype, "value", 2);
e([
  t({ type: Number })
], r.prototype, "max", 2);
e([
  t({ type: String, reflect: !0 })
], r.prototype, "variant", 2);
e([
  t({ type: String, reflect: !0 })
], r.prototype, "size", 2);
e([
  t({ type: Boolean, reflect: !0 })
], r.prototype, "indeterminate", 2);
e([
  t({ type: Boolean, attribute: "show-value" })
], r.prototype, "showValue", 2);
e([
  t({ type: String })
], r.prototype, "label", 2);
e([
  t({ type: Boolean })
], r.prototype, "striped", 2);
e([
  t({ type: Boolean })
], r.prototype, "animated", 2);
r = e([
  c("ark-progress")
], r);
export {
  r as A
};
//# sourceMappingURL=ark-progress-DWD-gmXW.js.map
